import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import StockInService from "../services/StockInService";

export default function ViewStockInDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await StockInService.getById(id);

        // your backend returns data inside res.data.data
        const stockIn = res?.data?.data || {};

        // details always inside stockIn.details
        setRows(stockIn.details || []);
      } catch (err) {
        console.error("Details load error:", err);
        setRows([]);
      } finally {
        setLoading(false); // ❤️ IMPORTANT FIX
      }
    };

    load();
  }, [id]);

  return (
    <>
      <Breadcrumb pageTitle="Stock In Details" secondTitle="Inventory" />

      <button
        style={{ margin: 10 }}
        className="btn btn-secondary"
        onClick={() => navigate(-1)}
      >
        ← Back
      </button>

      <div className="card p-3 bg-white shadow-sm">
        <h4>Item Details</h4>

        {loading ? (
          <div>Loading...</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>UOM</th>
                  <th>Quantity</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map((r, i) => (
                    <tr key={i}>
                      <td><span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{r.itemId}</span></td>
                      <td>{r.UOM}</td>
                      <td><span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{r.quantity}</span></td>
                      <td>{r.notes || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
